export default "__VITE_ASSET__DCuddnTR__"